import { Button } from "@/components/ui/button";
import { Slider } from "@/components/ui/slider";
import { Volume2, VolumeX } from "lucide-react";
import { useIsMobile } from "@/hooks/useResponsive";
interface PlayerActionControlsProps {
  volume: number;
  onVolumeChange: (value: number[]) => void;
}
export function PlayerActionControls({
  volume,
  onVolumeChange,
}: PlayerActionControlsProps) {
  const isMobile = useIsMobile();

  // Mobile expanded (per redesign) relies on hardware volume buttons and
  // shows Like next to the track title instead — this row is desktop-only.
  if (isMobile) {
    return null;
  }

  // Desktop layout
  return (
    <div className="flex flex-col gap-4 md:gap-6 mx-auto w-full mt-6 md:mt-8 max-w-lg font-archivo">
      {/* Volume Controls */}
      <div className="flex items-center justify-center gap-4">
        <span className="text-[#9A96C4] text-sm min-w-[50px]">Volume</span>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onVolumeChange(volume === 0 ? [80] : [0])}
          className="p-2 hover:bg-white/10"
        >
          {volume === 0 ? (
            <VolumeX className="h-5 w-5 text-[#9A96C4]" />
          ) : (
            <Volume2 className="h-5 w-5 text-[#9A96C4]" />
          )}
        </Button>
        <Slider
          value={[volume]}
          min={0}
          max={100}
          step={1}
          onValueChange={onVolumeChange}
          className="flex-1 max-w-32"
        />
        <span className="text-[#9A96C4] text-sm min-w-[35px]">{volume}%</span>
      </div>
    </div>
  );
}
